/* HDD 我的渲染劵列表 */
import { useEffect, useState } from 'react';
import { inject, observer } from 'mobx-react';
import { Table, Pagination, Tooltip } from 'antd';
import {} from '@ant-design/icons';
import {} from '&/utils/common';
import MyCoupons from '&/pages/rendering-voucher/components/myCoupons';
import { getListCoupon } from '&/api/personCenter/orderManage';
import { getUserInfo } from '@/api/Dialogs/signUpDlg';
import usePreventDefault from '@/utils/customHooks/usePreventDefault';
import './index.scss';

function MyRenderingCouponsModal(props) {
    const { appStore, location } = props;
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    usePreventDefault();
    const columns = [
        {
            title: intl.get('userCenter.tradeName'),
            dataIndex: 'productName',
            align: 'center',
            ellipsis: true,
        },
        {
            title: intl.get('userCenter.package'),
            dataIndex: 'pack',
            ellipsis: true,
        },
        {
            title: intl.get('userCenter.number'),
            dataIndex: 'orderAmount',
        },
        {
            title: intl.get('userCenter.discountAmount'),
            dataIndex: 'disAmount',
            render: money => `￥ ${money}`,
        },
        {
            title: intl.get('userCenter.paymentMethod'),
            dataIndex: 'payType',
            render: text => {
                const payTypeMap = {
                    0: intl.get('userCenter.offlinePayment'),
                    1: intl.get('userCenter.weChatPayment'),
                    2: intl.get('userCenter.alipayPayment'),
                };
                return payTypeMap[text];
            },
        },
        {
            title: intl.get('userCenter.orderAmount'),
            dataIndex: 'realMoney',
            render: money => `￥ ${money}`,
        },
        {
            title: intl.get('userCenter.orderNumber'),
            dataIndex: 'orderCode',
            align: 'center',
            ellipsis: true,
        },
        {
            title: intl.get('userCenter.orderTimes'),
            dataIndex: 'orderTime',
            align: 'center',
            ellipsis: true,
        },
        {
            title: intl.get('userCenter.validTo'),
            dataIndex: 'expireDate',
            align: 'center',
        },
        {
            title: () => {
                return (
                    <div className="title-tip-warp">
                        {intl.get('userCenter.bill')}
                        <Tooltip
                            placement="left"
                            title={intl.getHTML('userCenter.invoicePrompt')}>
                            <i className="icon-question-cirlce2 filled" />
                        </Tooltip>
                    </div>
                );
            },
            dataIndex: 'billingFlag',
            align: 'center',
            render: (val, record) => {
                const flagSet = [
                    <div className="invoice-unissued">
                        {intl.get('userCenter.billNotIssue')}
                        {/*<Tooltip placement="top" title={record.billingDeadline}>
                            <i className="filled icon-question-cirlce1" />
                        </Tooltip>*/}
                    </div>,
                    <div className="invoice-unissued">
                        {intl.get('userCenter.billIssued')}
                    </div>,
                    <div className="invoice-overdue">
                        {intl.get('userCenter.stale')}
                    </div>,
                    <div className="invoice-overdue">待开票</div>,
                ];
                return record.status === '02' && flagSet[val];
            },
            include: [2, 0],
            editable: true,
        },
    ];

    const [visible, setVisible] = useState(false);
    const [showTable, setShowTable] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [pageNum, setPageNum] = useState(1);
    const [total, setTotal] = useState(0);

    useEffect(() => {
        init();
    }, []);
    useEffect(() => {
        if (token) queryList();
    }, [pageNum]);

    const init = async () => {
        if (token) {
            appStore.setLoginData({ token }, false);
            await queryUserInfo();
            await queryList();
            setVisible(true);
        }
    };
    const openBuyPage = () => {
        try {
            const url = `${window.location.origin}/hdd/renderingCouponsList`;
            const urlParams = `?token=${token}&from=hddStartPage`;
            const sendData = {
                Url: `${url}${urlParams}`,
                Width: 1030,
                Height: 752,
            };
            window.external.DispatchFun(
                'StartPage',
                'ReloadUrl',
                JSON.stringify(sendData)
            );
        } catch (e) {}
    };
    const openYuQue = () => {
        window.open(
            `https://docs.foxithd.com/node/01978225-0e60-75ab-92b0-dec1aff701d8?channel=hdd`
        );
    };
    const gotoOrder = () => {
        setShowTable(true);
    };
    const hideTable = () => {
        setShowTable(false);
    };
    const queryUserInfo = async () => {
        try {
            const res = await getUserInfo();
            localStorage.setItem('HDDUserData', JSON.stringify(res.data));
        } catch (e) {}
    };
    const queryList = async () => {
        try {
            const sendData = {
                page: pageNum,
                limit: 20,
            };
            const res = await getListCoupon(sendData);
            setTableData(res.data.list);
            setTotal(res.data.total);
        } catch (e) {
            console.log(e);
        }
    };
    const onPageChange = value => {
        setPageNum(value);
    };

    const closeHddModal = () => {
        window.external.DispatchFun('StartPage', 'CloseRender', '');
    };

    return (
        <div className="my-rendering-coupons-modal">
            <div className="modal-header">
                <h3>{intl.get('rendering.myRenderingVoucher')}</h3>
                <i
                    className="icon-close filled"
                    onClick={closeHddModal}
                    style={{ visibility: showTable ? 'hidden' : 'visible' }}
                />
            </div>
            <div className="modal-content">
                <MyCoupons
                    visible={visible}
                    HDDOpenBuyPage={openBuyPage}
                    HDDOpenYuQue={openYuQue}
                    HDDGotoOrder={gotoOrder}
                />
            </div>
            <div
                className={`buy-order-table-box ${
                    showTable ? '' : 'hide-table'
                }`}>
                <div className="table-content-warp">
                    <div className="table-header">
                        <h3>{intl.get('userCenter.purchaseRecord')}</h3>
                        <i className="icon-close filled" onClick={hideTable} />
                    </div>
                    <Table
                        className="order-table"
                        columns={columns}
                        dataSource={tableData}
                        size="small"
                        rowKey={e => JSON.stringify(e)}
                        pagination={false}
                        scroll={{ y: true }}
                        rowClassName="custom-row"
                    />
                    <Pagination
                        size="small"
                        current={pageNum}
                        onChange={onPageChange}
                        pageSize={10}
                        total={total}
                        showSizeChanger={false}
                        showTotal={total => intl.get('base.total', { total })}
                    />
                </div>
            </div>
        </div>
    );
}
export default inject('appStore')(observer(MyRenderingCouponsModal));
